module.exports = "/images/everestPath2.png?fed0c8b1ad12145bb8c287fcf6f874b0";